import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const exportTimeKeepingHRSlice = createSlice({
  name: "exportTimeKeepingHR",
  initialState,
  reducers: {
    exportTimeKeepingHRStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    exportTimeKeepingHRSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    exportTimeKeepingHRFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  exportTimeKeepingHRStart,
  exportTimeKeepingHRSuccess,
  exportTimeKeepingHRFailed,
} = exportTimeKeepingHRSlice.actions;

export default exportTimeKeepingHRSlice.reducer;
